import { render, staticRenderFns } from "./candidate-list-container.vue?vue&type=template&id=736ab0d2&scoped=true&"
import script from "./candidate-list-container.vue?vue&type=script&lang=js&"
export * from "./candidate-list-container.vue?vue&type=script&lang=js&"
import style0 from "./candidate-list-container.vue?vue&type=style&index=0&id=736ab0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ab0d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
